import React from 'react';
import Drawer from 'components/gruenland/atoms/drawer/Drawer';
import { Menu } from 'components/gruenland/icons/Menu';
import { useFormat } from 'helpers/hooks/useFormat';
import { Category } from 'types/entity/category';
import { Tile } from '../../types';
import MobileMenuContent from './content/MobileMenuContent';
import MobileMenuHeader from './content/MobileMenuHeader';
import { useFilteredTiles } from './hooks/useFilteredTiles';
import { useMenuNavigation } from './hooks/useMenuNavigation';

export interface Props {
  links: Category[];
  tiles: Tile[];
  onSearchClick?: () => void;
}

const HeaderNavigationMobile: React.FC<Props> = ({ links, tiles, onSearchClick }) => {
  const { formatMessage } = useFormat({ name: 'gruenland' });
  const { menuState, actions } = useMenuNavigation();
  const filteredTiles = useFilteredTiles(tiles, menuState.currentCategory);

  return (
    <>
      <button
        onClick={actions.openMenu}
        title={formatMessage({
          id: 'common.openSideMenu',
          defaultMessage: 'Apri il menu laterale',
        })}
        className="md:hidden"
      >
        <Menu />
      </button>

      <Drawer isOpen={menuState.isOpen} direction="left" className="w-4/5" onClose={actions.closeMenu}>
        <MobileMenuHeader
          categories={menuState.navigationStack.map((level) => level.category).filter(Boolean) as Category[]}
          hideHeaderMenu={actions.closeMenu}
          onArrowClick={actions.navigateBack}
        />

        <MobileMenuContent
          links={links}
          hideHeaderMenu={actions.closeMenu}
          categoriesNavigator={menuState.navigationStack.map((level) => level.category).filter(Boolean) as Category[]}
          insertCategory={actions.navigateToCategory}
          tileContent={filteredTiles}
          onSearchClick={onSearchClick}
        />
      </Drawer>
    </>
  );
};

export default HeaderNavigationMobile;
